import { render } from "./CookieComply.vue?vue&type=template&id=a674edbe"
import script from "./CookieComply.vue?vue&type=script&lang=js"
export * from "./CookieComply.vue?vue&type=script&lang=js"

import "./CookieComply.vue?vue&type=style&index=0&id=a674edbe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__